import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { COMMON_CONSTANTS } from 'src/app/common/constants/common-constants';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { ModuleService } from '../../services/module.service';
import { LoaderService } from 'src/app/common/services/loader.service';

interface Client {
  ClientName: string;
  showStudies: boolean;
  UniqueStudies: string[];
}

@Component({
  selector: 'app-module-landing',
  templateUrl: './module-landing.component.html',
  styleUrls: ['./module-landing.component.css']
})
export class ModuleLandingComponent {

  CrossTabName: string = COMMON_CONSTANTS.CrossTabModuleName;
  SnapShotName: string = COMMON_CONSTANTS.SnapShotModuleName;
  BrandAnalysisName: string = COMMON_CONSTANTS.BrandAnalysisModuleName;
  ArkName: string = COMMON_CONSTANTS.ARKName;

  studydropdown: boolean = false;
  Acrossdropdowncheck: boolean = false;
  IsSnapshot: boolean = false;
  enableExplore: boolean = false;
  enableConfig: boolean = false;
  studyname: any = "study Name";
  Acrossname: any = "compare Across";
  filteredData: any[] = [];
  popUpData: any;
  AcrossDropdown: any;
  studyNamesCount: any = 0;
  studyNamesArray: any;
  filteredStudyNamesArray: any;
  searchStudyText: string = '';
  snapshotselected: any = "";
  sectionSelected: any = "";
  subsectinselected: any = "";
  exploreBtn: string = "Explore";
  IsBrandAnalysis: boolean = false;
  snapshotType: any = [];

  @Input() moduleName: string = '';
  @Input() studyNames: any;
  @Input() studyName: any = '';
  @Input() ClientName: any;
  @Input() isSuperAdmin: any;
  @Input() configData: any;

  private subscriptions: Subscription = new Subscription();

  constructor(private router: Router,
    private _loaderService: LoaderService, private _configService: SnapshotService, private moduleService: ModuleService,
    public SharedPopupService: SharedPopupService, private _configCustomService: CustomsnapshotService) { }

  ngOnInit() {
    if (!this.isSuperAdmin) {
      this.navigateToModule();
    }
    if (this.moduleName == this.SnapShotName) {
      this.studyname = "Snapshot Name";
      this.getPopUpeData();
      this.toggleStudies(this.ClientName);
      this.IsSnapshot = true;
      this.studyNamesCount = this.studyNames.length;
      this.studyNamesArray = this.studyNames;
      this.filteredStudyNamesArray = this.studyNamesArray;
      if (this.studyNamesCount < 6)
        this.enableConfig = true;
      //this.studyNameclick(this.studyName);
    }
    else {
      this.exploreBtn = this.isSuperAdmin ? this.exploreBtn : this.exploreBtn;
      this.studyNamesCount = this.studyNames.length;
      this.studyNamesArray = this.studyNames;
      this.filteredStudyNamesArray = this.studyNamesArray;
      this.studyname = this.studyName;
       this.IsSnapshot = false;
    }
  }

  getPopUpeData(): void {
    this.SharedPopupService.setPopUpTabData$.subscribe((data) => {
      if (data != null && data.data.length > 0) {
        //data=this.restrictClientsBasedOnEmailID(data);
        this.popUpData = data.data;
        //this.moduleName = data.moduleName
        this.filteredData = data.data;
        this._configService.SnapshotList = data.data;
        //this.ShowAccessLevel();
      }
    });
  }

  openstudyDropdown() {
    this.Acrossdropdowncheck = false;
    this.studydropdown = !this.studydropdown;
  }

  studyNameclick(name: any) {
    this.studyname = name;
    if (!this.IsSnapshot) {
      this.enableExplore = true;
    }

    this.enableConfig = true;
    this.Acrossname = "compare Across";
    this.studydropdown = false;
    this.AcrossDropdown = [];
    if (this.IsSnapshot)
      this.bindingAcrossDropdown();
  }

  AcrossNameclick(snapshot_name: any, sectionname: any, subsection: any) {
    this.snapshotselected = snapshot_name;
    this.sectionSelected = sectionname;
    this.subsectinselected = subsection;
    this._configService.snapshotSelectedName = this.snapshotselected;
    this._configService.selectedSection = this.sectionSelected;
    this._configService.selectedSubSection = this.subsectinselected;
    this.Acrossdropdowncheck = false;
    if (subsection == '')
      this.Acrossname = snapshot_name.toUpperCase() + ' : ' + sectionname;
    else
      this.Acrossname = snapshot_name.toUpperCase() + ' : ' + sectionname + ' : ' + subsection;

    this.enableConfig = true;
    this.enableExplore = true;
  }

  configuration() {
    if (this.IsSnapshot) {
      if (this.studyname == 'Snapshot Name') {
        let data: { client_name: string; study: string; configdata: any } = {
          client_name: this.ClientName,
          study: "",
          configdata: this.filteredData,
        };
        this.router.navigateByUrl('Snapshot/configuaration', { state: data });
      }
      else {
        let data: { client_name: string; study: string; configdata: any; snapshotselected: string, sectionselected: any; subsectionselected: any } = {
          client_name: this.ClientName,
          study: this.studyName,
          configdata: this.filteredData,
          snapshotselected: this.studyname,
          sectionselected: this._configService.selectedSection,
          subsectionselected: this._configService.selectedSubSection
        };
        this.router.navigateByUrl('Snapshot/configuaration', { state: data });
      }
    } else {

      let data: { client_name: string; study: string } = {
        client_name: this.ClientName,
        study: this.studyName,
      };
      this.router.navigateByUrl('configuration', { state: data });
    }
  }


  toggleStudies(clickedClient: any): void {
    // Close other clients if they are open
    this.popUpData?.forEach((client: Client) => {
      if (client.ClientName !== clickedClient) {
        client.showStudies = false;
      }
      else {
        client.showStudies = true;
      }
    });

    // Toggle the studies for the clicked client
    // clickedClient.showStudies = !clickedClient.showStudies;
  }
  filterStudyNames(): void {
    if (!this.searchStudyText || this.searchStudyText.trim() === '') {
      this.filteredStudyNamesArray = this.studyNamesArray;
    } else {
      const searchText = this.searchStudyText.toLowerCase().trim();
      this.filteredStudyNamesArray = this.studyNamesArray.filter(
        (item: string) => item.toLowerCase().includes(searchText)
      );
    }
  }

  handleDocumentClick(event?: any): void {
    // If no proper event is provided, simply close the dropdown
    if (!event || !event.target) {
      this.studydropdown = false;
      return;
    }
    
    // Check if the click happened inside the dropdown
    const dropdown = document.querySelector('.Dropdown-popup-study');
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.studydropdown = false;
    }
  }

  handleAcrossDocumentClick(event?: any): void {
    // If no proper event is provided, simply close the dropdown
    if (!event || !event.target) {
      this.Acrossdropdowncheck = false;
      return;
    }
    
    // Check if the click happened inside the dropdown
    const dropdown = document.querySelector('.Dropdown-popup-Across');
    if (dropdown && !dropdown.contains(event.target as Node)) {
      this.Acrossdropdowncheck = false;
    }
  }

  openacrossDropdown() {
    if (this.studyname != "study Name" && this.ClientName != '') {
      this.Acrossdropdowncheck = !this.Acrossdropdowncheck;
    }
  }

  bindingAcrossDropdown() {
    this._loaderService.showLoader();
    if (this.studyname != "study Name" && this.ClientName != '') {
      let snapshotData = {
        ClientName: this.ClientName,
        SnapshotName: this.studyname
      }      
      this._configService
          .getClientStudyData({
            client_code: this.ClientName,
            snapshot_name: this.studyname,
          })
          .subscribe({
            next: (response) => {
              const data = JSON.parse(response.body?.Data ?? '{}');

              if (data?.snapshotType_details) {
                this.snapshotType = data.snapshotType_details;
              }
              if(data?.saveselection){
                this._configService.globalDefaultSelectionFlag = data.saveselection.find(
                  (item: { key: string; value: boolean }) => item.key === "Global Default Selection"
                )?.value ?? false;
              }
              this._configCustomService.getCustomSnapshotWidgetLibrary(snapshotData).subscribe((r: any) => {
                let data = r?.Data
                let configuredSnapshotTypes = JSON.parse(data);        
                const snapshotTypeSet = new Set(
                  this.snapshotType.map((item: { snapshot_type: string }) => item.snapshot_type)
                );
                
                configuredSnapshotTypes.snapshotType = configuredSnapshotTypes.snapshotType.filter(
                  (item: { snapshotType_name: string }) =>
                    snapshotTypeSet.has(item.snapshotType_name)
                );
                
                const sortOrder = ['Single Brand', 'Multiple Brands', 'Multiple Markets'];
                configuredSnapshotTypes.snapshotType.sort((a: any, b: any) => {
                  return sortOrder.indexOf(a.snapshotType_name) - sortOrder.indexOf(b.snapshotType_name);
                });
                
                this.AcrossDropdown = configuredSnapshotTypes?.snapshotType;
                this._configService.AcrossDropdown = this.AcrossDropdown;
                sessionStorage.setItem("AcrossDropdown", JSON.stringify(this.AcrossDropdown));
                this._loaderService.hideLoader();
              },
                (error) => {
                  // Handle any errors here
                 
                  console.error('Error:', error);
                  this._loaderService.hideLoader();
                }
              );
            },
            error: (err) => {             
              console.error('Error fetching client study data:', err);
              this._loaderService.hideLoader();
            }
          });
    }
  }

  navigateToModule() {
    let data: { client_code: string; study: string; studyList: any } = {
      client_code: this.ClientName,
      study: this.studyName,
      studyList: this.studyNamesArray
    };
    switch (this.moduleName) {
      case this.SnapShotName:
        this.navigateToSnapshot();
        break;
      case this.CrossTabName:
        this.router.navigateByUrl('Crosstab', { state: data });
        break;
      case this.BrandAnalysisName:
        this.router.navigateByUrl('BrandAnalysis', { state: data });
        break;
      case this.ArkName:
        this.router.navigateByUrl('chatbotexpand', { state: data });
        break;
    }
  }

  navigateToSnapshot() {
    this.subscriptions.add(this._configService
      .getClientStudyData({
        client_code: this.ClientName,
        snapshot_name: this.studyname,
      })
      .subscribe(async (b) => {
        var x = JSON.parse(b.body.Data);
        if (
          x != null &&
          x != undefined &&
          x != ''
        ) {
          let mainStudy = x.study_list[0].study_name;
          // let data: { client_code: string; study: string } = {
          //   client_code: this.selectedClientCode,
          //   study: this.selectedStudy,
          // };

          let data: { client_code: string; study: string; main_study: string, snapList: any, snapshotselected: string, sectionselected: any; subsectionselected: any } = {
            client_code: this.ClientName,
            study: this.studyname,
            main_study: mainStudy,
            snapList: this._configService.SnapshotList?.filter((a: any) => a.ClientName == this.ClientName),
            snapshotselected: this._configService.snapshotSelectedName,
            sectionselected: this._configService.selectedSection,
            subsectionselected: this._configService.selectedSubSection,
          };

          localStorage.setItem("snapshotselected_landing", this._configService.snapshotSelectedName);
          localStorage.setItem("sectionselected_landing", this._configService.selectedSection);
          localStorage.setItem("subsectionselected_landing", this._configService.selectedSubSection);


          if (x.product == "Standard") {
            this.router.navigateByUrl('Snapshot/snapshot-output', { state: data });
          }
          else if (x.product == "Custom") {
            this.router.navigateByUrl('Snapshot/custom-snapshot-output', { state: data });
          }

        }
        else {
          this.router.navigateByUrl('landing');
        }
      }));
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }


}
